import * as React from "react";

export const BackModalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.5 1L2 9.5L10.5 18" stroke="white" strokeWidth="2" />
  </svg>
);
